<!--
 * @Author: chenguanbin
 * @Date: 2020-03-13 18:33:59
 * @Desc: 实时企业预警
 -->
<template>
  <h-page-container>
    <h-page-header slot="pageHeader" :breadcrumb="breadcrumb" />
    <h-page-content ref="pageContent" flex>
      <h-page-search ref="search" :model="search">
        <h-page-search-item label="企业名称" prop="enterpriseName">
          <el-input v-model="search.enterpriseName" />
        </h-page-search-item>
        <h-page-search-item label="预警规则名称" prop="alertTypeCode">
          <el-select v-model="search.alertTypeCode">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="(item, index) in alertTypeCodeOpts"
              :key="index"
              :label="item.alertTypeName"
              :value="item.alertTypeCode"
            />
          </el-select>
        </h-page-search-item>
        <h-page-search-item label="处置状态" prop="status">
          <el-select v-model="search.status">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="(key, type) in STATUS_TYPE_NAME"
              :key="key"
              :label="key"
              :value="type"
            />
          </el-select>
        </h-page-search-item>
        <template v-slot:pageSearchAction>
          <el-button type="primary" @click="refreshTable">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </template>
      </h-page-search>
      <div class="adapt-table">
        <el-table :data="tableData" show-overflow-title force-scroll>
          <!-- <el-table-column type="selection" width="55" /> -->
          <el-table-column prop="time" label="预警时间" />
          <el-table-column prop="enterpriseName" label="企业名称" />
          <el-table-column prop="alertTypeName" label="预警规则名称" />
          <el-table-column prop="statusName" label="处置状态" />
          <el-table-column prop="srcName" label="预警源" />
          <el-table-column label="操作">
            <template slot-scope="scope">
              <i
                class="icon-edit"
                @click="handleOpenDialog(scope.row.alertEventId, scope.row.status)"
              ></i>
              <!-- <el-button
                type="iconButton"
                size="mini"
                icon="h-icon-edit"
                @click="handleOpenDialog(scope.row.alertEventId, scope.row.status)"
              /> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div>
        <el-pagination
          :current-page="pagination.pageNo"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          :total="pagination.total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </h-page-content>

    <!-- 实时预警 - 审核弹出框 -->
    <RealtimeWarningDialog
      ref="dialog"
      :is-disabled="isDealDisabled"
      :is-comment-disabled="isCommentDisabled"
      @dialogClose="handleCloseDialog"
    />
  </h-page-container>
</template>

<script>
import tableMixins from '@/mixins/tableMixins'
import RealtimeWarningDialog from './RealtimeWarningDialog'
import http from '@/api/warningManage.api'
import { STATUS_TYPE_NAME, STATUS_NOT_CHECK, STATUS_NOT_DEAL } from './constants'
import { mapMutations, mapState } from 'vuex'

export default {
  name: 'RealtimeWarning',
  components: { RealtimeWarningDialog },
  mixins: [tableMixins],
  data() {
    return {
      tableData: [],
      search: {
        enterpriseName: '',
        alertTypeCode: '',
        status: this.$route.params.status ? String(this.$route.params.status) : ''
      },
      STATUS_TYPE_NAME,
      isDealDisabled: true,
      isCommentDisabled: true,
      alertTypeCodeOpts: []
    }
  },
  computed: {
    ...mapState(['alertEvent'])
  },
  watch: {
    // 接收到打开预警详情的id改变时，弹详情弹窗
    'alertEvent.notifyEventId'(data) {
      if (data) {
        this.handleOpenDialog(data, STATUS_NOT_DEAL)
        this.setAlertEventNotifyId()
      }
    }
  },
  created() {
    this.refreshTable()
    this.emmsAlertLevelConfigAlertTypeList()
  },
  mounted() {
    this.resolveRouterParams()
  },
  methods: {
    ...mapMutations(['setAlertEventNotifyId']),

    /**
     * @author xuchen
     * @date 2021-11-30 15:59:28
     * @desc 处理路由参数
     */
    resolveRouterParams() {
      const { openDialogEventId } = this.$route.params
      openDialogEventId && this.handleOpenDialog(openDialogEventId, STATUS_NOT_DEAL)
    },

    /**
     * @author chenguanbin
     * @date 2020-03-14 10:01:46
     * @desc 点击表格中的图标，打开弹出框
     */
    handleOpenDialog(alertEventId, status) {
      this.isDealDisabled = true
      this.isCommentDisabled = true
      String(status) === STATUS_NOT_CHECK && (this.isDealDisabled = false)
      String(status) === STATUS_NOT_CHECK && (this.isCommentDisabled = false)
      this.$refs.dialog.openDialog(alertEventId)
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-24 16:09:30
     * @Desc: 关闭弹窗并清空数值刷新列表
     */
    handleCloseDialog() {
      this.refreshTable()
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-19 14:36:37
     * @Desc: 查询实时预警事件
     */
    async refreshTable() {
      const { data } = await http.getProcessingEvents({
        regionPath: this.$store.state.regionPath,
        ...this.pagination,
        ...this.search
      })
      this.pagination.total = data.total
      this.tableData = data.rows
    },
    /**
     * @Author: maogangfeng
     * @Date: 2020-03-19 20:31:27
     * @Desc: 获取预警类型列表
     */
    async emmsAlertLevelConfigAlertTypeList() {
      const { data } = await http.emmsAlertLevelConfigAlertTypeList()
      this.alertTypeCodeOpts = data
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-edit {
  display: inline-block;
  width: 24px;
  height: 24px;
  background: url(~@/assets/images/realtimeWarning/edit.png) no-repeat;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
}
</style>
